import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles({
    modalWrapper: {
        padding: '24px 28px',
        width: '100%',
        maxWidth: 520,
        minHeight: 320,
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        alignSelf: 'center',
        boxSizing: 'border-box',
        boxShadow: '0px 8px 28px rgba(0,0,0,0.24)',
        borderRadius: 12,
        backgroundColor: ({ theme }) => theme.palette.bgColor,
        outline: 'none'
    },
    text: {
        color: ({ theme }) => theme.palette.text.primary,
        margin: 0
    },
    popup: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 16,
    },
    btnWrapper: {
        marginTop: 'auto',
        display: 'flex',
        justifyContent: 'center',
        gap: 16,
        paddingTop: 16,
        borderTop: '1px solid rgba(255,255,255,0.08)'
    },
    multiline: {
        whiteSpace: 'pre-line'
    },
    fontBold: {
        fontWeight: '600'
    },
    textInput: {
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
            { border: ({ theme }) => `1px solid ${theme.palette.text.primary}`, },
    },
    inputLabel: {
        display: 'flex',
        justifyContent: 'flex-start',
        height: '100%'
    },
})